export default function ProductFormSkeleton() {
  return (
    <div className="min-h-screen space-y-4 px-4 py-6">
      <div className="h-8 w-48 animate-pulse rounded bg-[#F0E0C7]/60" />
      <div className="space-y-4 rounded-xl border bg-white p-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={`product-form-field-${index}`} className="space-y-2">
            <div className="h-4 w-24 animate-pulse rounded bg-[#F0E0C7]/60" />
            <div className="h-10 w-full animate-pulse rounded-lg bg-[#F0E0C7]/60" />
          </div>
        ))}
      </div>
      <div className="space-y-3 rounded-xl border bg-white p-4">
        <div className="h-6 w-32 animate-pulse rounded bg-[#F0E0C7]/60" />
        {Array.from({ length: 2 }).map((_, index) => (
          <div
            key={`product-variant-${index}`}
            className="h-32 w-full animate-pulse rounded-lg bg-[#F0E0C7]/60"
          />
        ))}
      </div>
    </div>
  );
}
